import { render, staticRenderFns } from "./RoleEditDialog.vue?vue&type=template&id=1705242a&"
import script from "./RoleEditDialog.vue?vue&type=script&lang=js&"
export * from "./RoleEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./RoleEditDialog.vue?vue&type=style&index=0&id=1705242a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports